import Nullstack from 'nullstack';
export default function IconAugmentedReality2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-augmented-reality-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M10 21h-2a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v3.5"
  }), "   ", Nullstack.element("path", {
    d: "M17 17l-4 -2.5l4 -2.5l4 2.5v4.5l-4 2.5z"
  }), "   ", Nullstack.element("path", {
    d: "M13 14.5v4.5l4 2.5"
  }), "   ", Nullstack.element("path", {
    d: "M17 17l4 -2.5"
  }), "   ", Nullstack.element("path", {
    d: "M11 4h2"
  }), " ");
}